<template>
    <modal v-if="showModal" :closeOnClick="true" :title="title" :isOpen="true"
        class="modal-view--bg modal-view--page-search modal-view--with-icon" @close="closeModal">
        <filter-icons v-if="titleIcon" :icon="titleIcon" slot="icon"></filter-icons>
        <page-search-widget @shownselector="(s) => selectorShown = s" :queryParams="searchQueryParams"></page-search-widget>
    </modal>
</template>

<script>
import Modal from '../modal.vue';
import PageSearchWidget from '../page-search-widget.vue';
import FilterIcons from './partials/filter-icons.vue';
import _ from 'underscore';

export default {
    data() {
        return {
            showModal: false,
            searchQueryParams: {},
            selectorShown: null
        }
    },
    mounted() {
        if (this.$route.query.searchwidget) {
            this.showModal = true;
        }
    },
    watch: {
        showModal() {
            if (this.showModal) {
                this.parseRouteKeywords();
            }
        },
        "$route.query.searchwidget"() {
            if (this.$route.query.searchwidget) {
                this.showModal = true;
            }
        }
    },
    methods: {
        parseRouteKeywords() {
            this.searchQueryParams = _.pick(this.$route.query,
                [
                    'boardTypeCode',
                    'minHotelCategory',
                    'keywords',
                    'directFlight',
                ]
            );
        },
        closeModal() {
            if (this.selectorShown) {
                return;
            }

            this.showModal = false;
            this.$router.replace({
                query: {}
            });
        }
    },
    computed: {
        translation() {
            return (
                window.APP_CONFIG &&
                window.APP_CONFIG.TRANSLATION &&
                window.APP_CONFIG.TRANSLATION.PAGE_SEARCH_WIDGET_MODAL
            ) ? window.APP_CONFIG.TRANSLATION.PAGE_SEARCH_WIDGET_MODAL : {}
        },
        keyWordTitle() {
            const keywords = this.searchQueryParams.keywords ? JSON.parse(this.searchQueryParams.keywords) : [];
            if (keywords.length === 1) {
                switch (keywords[0]) {
                    case 'ben':
                        return this.translation.close_on_beach_title;
                    case 'transfer-MT':
                        return this.translation.inclusive_transfer_title;
                    case 'chf':
                        return this.translation.child_frendly_title;
                    case 'ado':
                        return this.translation.adults_only_title;
                    case 'lcs':
                        return this.translation.central_location_title;
                }
            }

            return null;
        },
        titleIcon() {
            const keywords = this.searchQueryParams.keywords ? JSON.parse(this.searchQueryParams.keywords) : [];
            if (keywords.length === 1) {
                switch (keywords[0]) {
                    case 'ben':
                        return 'Beach';
                    case 'transfer-MT':
                        return 'IT';
                    case 'chf':
                        return 'CF';
                    case 'ado':
                        return 'AD'
                    case 'lcs':
                        return 'CL';
                    default:
                        return '';
                }
            } else if (this.searchQueryParams.minHotelCategory == 4) {
                return '4star'
            } else if (this.searchQueryParams.boardTypeCode == 'AI') {
                return 'all-iclusive';
            } else if (this.searchQueryParams.directFlight) {
                return 'DF';
            }

            return '';
        },
        customTitle() {
            if (this.searchQueryParams.minHotelCategory == 4) {
                return this.translation.min_4_stars_title;
            } else if (this.searchQueryParams.boardTypeCode == 'AI') {
                return this.translation.all_inclusive_title;
            } else if (this.searchQueryParams.directFlight) {
                return this.translation.direct_flight_title;
            }
        },
        title() {
            if (this.keyWordTitle) {
                return `${this.keyWordTitle} - ${this.translation.choose_destination_tittle}`;
            } else if (this.customTitle) {
                return `${this.customTitle} - ${this.translation.choose_destination_tittle}`;
            } else {
                return this.translation.choose_destination_tittle;
            }
        }
    },
    components: {
        Modal,
        PageSearchWidget,
        FilterIcons
    }
}
</script>